export default "__VITE_ASSET__C3fe8i59__"